class AccountDeleteModalController extends AbstractController
	@register()
	@inject 'translate'

	initialize: ->
		@confirmationValue = null
		@confirmationHash = @translate('wbo.account.delete_me').toUpperCase()

	onChange: ->
		@form.$setValidity('confirmation', @confirmationValue == @confirmationHash)
